import React, { Component } from 'react';
import Hero from "../modules/Hero/Hero";

class NotFound extends Component {

    render() {
        const BgClass = () => {
            let random = ['internet', 'voice', 'managed-services', 'network-solutions', 'partners'];
            return 'error-bg-' + random[Math.floor(Math.random() * random.length)];
        };
        
        return (
            <Hero
                title="Whoops!"
                leadCopy={['Sorry to break it to you, but this page does not exist!']}
                addClass={BgClass()}
            />
        );
    }

}

export default NotFound;


// WEBPACK FOOTER //
// ./resources/assets/js/pages/NotFound.js